//电子券发票类型
export enum InvoiceELectron {
    '未设置',
    '专票纸质版',
    '专票电子版',
    '普票纸质版',
    '普票电子版',
    '无票',
    '其他',
}

// 券包类型
export enum CouponType {
    '采购' = 1,
    '自制',
}